@if ((viewModel$ | async); as vm) {
<div class="request-document-page">
    <mat-card class="page-banner">
        <div class="banner-copy">
            <div class="eyebrow">Document-first triage</div>
            <h1>Shared Clinical Request Document</h1>
            <p>
                Review the bundled referral snapshot first. Move into the local patient chart only after the destination
                team
                accepts the handoff or links it to a destination-owned patient shell.
            </p>
            <p class="current-patient">
                Currently reviewing <strong>{{ vm.patientDisplay }}</strong>.
            </p>
        </div>

        <div class="banner-actions">
            <button mat-stroked-button type="button" (click)="back()">
                <mat-icon>arrow_back</mat-icon>
                Back
            </button>

            @if (vm.patientId) {
            <a mat-flat-button [routerLink]="patientSummaryLink(vm.patientId)">
                <mat-icon>folder_shared</mat-icon>
                Open Patient Chart
            </a>
            }
        </div>
    </mat-card>

    <mat-card class="patient-shell-card" [class.disabled]="!vm.canCreatePatientShell"
        [class.linked]="vm.hasLocalPatientShell">
        <div class="card-copy">
            <div class="eyebrow">Destination Patient Shell</div>
            <h2>Anchor {{ vm.patientDisplay }} locally</h2>
            <p>
                Creating a local patient shell copies the demographics from the shared referral bundle into
                {{ vm.destinationOrganizationDisplay || 'your organization' }} so your team can safely begin downstream
                documentation.
            </p>

            @if (vm.hasLocalPatientShell) {
            <p class="status shell-ready">
                A local patient shell already exists for this referral.
            </p>
            } @else if (vm.canCreatePatientShell) {
            <p class="status shell-ready">
                Referral Identifier: {{ vm.referralIdentifier || 'pending assignment' }}
            </p>
            } @else {
            <p class="status shell-muted">{{ vm.shellDisabledReason }}</p>
            }

            @if (shellCreationError) {
            <p class="status shell-error">{{ shellCreationError }}</p>
            }
        </div>

        <div class="card-actions">
            @if (vm.hasLocalPatientShell && vm.patientId) {
            <a mat-flat-button color="primary" [routerLink]="patientSummaryLink(vm.patientId)">
                <mat-icon>folder_shared</mat-icon>
                Open Patient Chart
            </a>
            } @else {
            <button mat-flat-button color="primary" type="button"
                [disabled]="!vm.canCreatePatientShell || creatingShell" (click)="createDestinationPatientShell(vm)">
                <mat-icon>person_add</mat-icon>
                <span>Create Local Patient</span>
                @if (creatingShell) {
                <mat-progress-spinner diameter="18" mode="indeterminate" class="inline-spinner"></mat-progress-spinner>
                }
            </button>
            }
        </div>
    </mat-card>

    @if (vm.bundle) {
    <app-referral-document-viewer [referralBundle]="vm.bundle"
        fallbackTitle="Incoming Clinical Document"></app-referral-document-viewer>
    } @else {
    <mat-card class="empty-state-card">
        <mat-card-title>No bundled document available</mat-card-title>
        <mat-card-content>
            This request does not currently expose a referral document bundle to the viewer. For cross-organization
            work,
            attach the document package to the ServiceRequest before routing users into this screen.
        </mat-card-content>
    </mat-card>
    }
</div>
}